export const FETCH_LOGOUT_INIT = 'FETCH_LOGOUT_INIT';
export const FETCH_LOGOUT_SUCCESS = 'FETCH_LOGOUT_SUCCESS';
export const FETCH_LOGOUT_FAILURE = 'FETCH_LOGOUT_FAILURE';
